import React, { useEffect, useRef, useState } from "react";
import { Paper, Grid, Typography } from "@material-ui/core";
import useStyles from "../../styles/deviceStyle";
import { useTranslation } from "../../langs/useTranslation";
import { useParams } from "react-router-dom";
import SmallerLoadingIndicator from "../commons/SmallerLoadingIndicator";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import {
  dataSetConnection,
  optionsConnection
} from "../../helpers/chartDataSet";
import { getRealTimeData } from "../../helpers/getRealTimeData";
import { dateInNormal } from "../../helpers/datetimeHandlers";
import useStateOnMounted from "../../helpers/useStateOnMounted";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const DeviceDetailConnectionGraph = props => {
  const { t } = useTranslation("device");
  const classes = useStyles();
  const { device_id } = useParams();
  const [valueArr, setValueArr] = useStateOnMounted([]);
  const [labelArr, setLabelArr] = useStateOnMounted([]);
  const [date, setDate] = useStateOnMounted("");
  const [unit, setUnit] = useStateOnMounted();
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);
  const mounted = useRef(null);
  const { graphType, mins, dateInHour } = props;

  const getData = async () => {
    setLoading(true);
    let data = await getRealTimeData(device_id, graphType, 7, mins, dateInHour);
    if (data) {
      setValueArr(data.valueArr);
      setLabelArr(data.labelArr);
      setDate(dateInHour.format("YYYY-MM-DD HH:00"));
      const dataUnit = data.unit[0];
      if (dataUnit === "&#8451;") {
        const unicode = dataUnit.match(/\d+/);
        setUnit(String.fromCharCode(unicode));
      } else {
        setUnit(dataUnit);
      }
      setLoading(false);
    }
  };

  const data = {
    labels: labelArr,
    datasets: [dataSetConnection(valueArr)]
  };

  useEffect(() => {
    const runTask = async () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      if (mounted.current === false) return;
      await getData();
      timer.current = setTimeout(() => {
        runTask();
      }, 60 * 1000);
    };
    runTask();
  }, [mins, dateInHour]);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper
          elevation={0}
          className={`${classes.marginBottomReset} ${classes.graphWrap}`}
        >
          <Typography
            variant="subtitle2"
            align="center"
            className={classes.graphDate}
          >
            {t("deviceInformation.date")}
            {date}
          </Typography>
          <Typography
            variant="caption"
            align="right"
            className={classes.graphUnit}
          >
            {graphType === "connection" ? "" : unit}
          </Typography>
          <div className={classes.graphContainer}>
            {loading && (
              <SmallerLoadingIndicator className={classes.loadingWrapper} />
            )}
            <Line data={data} options={optionsConnection} />
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default DeviceDetailConnectionGraph;
